/**
 * The post-login intent kinds — what the user asked for immediately before
 * being sent through sign-in. The carrier itself (park/read/clear over ONE
 * localStorage key) lives in `lib/postLoginIntent`; these are the domain
 * shapes it stores.
 */

export enum PostLoginIntentKind {
  /** Deploy an existing team: the team modal opens with deploy invoked. */
  TeamModalDeploy = "team_modal_deploy",
  /** Build a team: the team modal opens on an empty subject, edit invoked. */
  TeamModalNewTeam = "team_modal_new_team",
  /** Resume a plan checkout for the parked price. */
  PlanCheckout = "plan_checkout",
}
